export default "__VITE_ASSET__BmqBCjmC__"